import { RaModule } from 'resources/RaModule';
import { ResourceName, ResourceIntent } from 'shared/enums';

export const CustomersModule = RaModule.fromResourceProps({
  name: ResourceName.CUSTOMERS,
  intent: ResourceIntent.REGISTRATION
});
